
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skill-instance/[instanceId]",
      function () {
        return require("private-next-pages/skill-instance/[instanceId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skill-instance/[instanceId]"])
      });
    }
  